// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ENVIRONMENT } from 'emma-common-ts';
import { EMMAEnvironment } from 'emma-common-ts/emma';

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment: EMMAEnvironment = {
  production: false,
  apiUrl: 'http://localhost:3000',
  baseUrl: 'http://localhost:4200',
  s3Host: 'scw.cloud',
  s3SecretKey: '4af8e1fd-4ffd-4df1-9dc1-24ae61a8820e',
  s3AccessKey: 'SCWYJ8W02P2VW3BBKE1D',
  s3Region: 'nl-ams',
  shortLinkDomain: 'localhost:8001',
  shortLinkProtocol: 'http',
  facebookAppId: '1194220137939018',
  tiktokAppId: '7414057875653279745',
  googleAdsClientId: '976671935890-tk0jp657ksqvsd9vusv38fsd13hn0j37.apps.googleusercontent.com',
  gtmId: 'GTM-T8FT49M8',
  env: ENVIRONMENT.DEVELOPMENT,
  skudoDomain: 'localhost:4200',
  amazonDspEmmaClientId: 'amzn1.application-oa2-client.e59b967a46db477296a51b64c8e8158b',
  aiServiceUrl: 'http://localhost:8002',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
